// extracted by mini-css-extract-plugin
export default {"thumbnail":"thumbnail_dH99o5k6","product-card__special-name":"product-card__special-name_Hk08jLtp"};